import { render, staticRenderFns } from "./simOpenTnPNew.vue?vue&type=template&id=3530d01a&scoped=true&"
import script from "./simOpenTnPNew.vue?vue&type=script&lang=js&"
export * from "./simOpenTnPNew.vue?vue&type=script&lang=js&"
import style0 from "./simOpenTnPNew.vue?vue&type=style&index=0&id=3530d01a&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3530d01a",
  null
  
)

export default component.exports